import { reactive } from "vue";
import { useFilters } from "@/composables/filters/useFilters";

let instance = null;

export function useEmployeeDirectoryViewState() {
  if (instance) return instance;
  const filter = useFilters();
  const state = reactive({
    filters: {
      values: [],
      searchText: "",
      showFilterDialog: false,
      key: "readinessEmployees",
      clearSelection: "",
      needsRecalculation: false,
    },
    loading: {
      table: false,
    },
    table: {
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      search: "",
    },
    showEmployeeBadgesList: false,
    selectedEmployee: null,
  });

  const applyFilters = (filters) => {
    const newArray = filters
      .map((item) => {
        if (item.value !== null) {
          if (typeof item === "string") {
            return item;
          } else if (
            typeof item === "object" &&
            // eslint-disable-next-line no-prototype-builtins
            item.hasOwnProperty("value")
          ) {
            return item.value;
          }
        }
      })
      .filter(Boolean);
    filter.setFilters({ key: state.filters.key, filters: newArray });
    state.filters.values = newArray;
    state.filters.showFilterDialog = false;
  };

  const removeFilters = (removedFilters) => {
    filter.setFilters({
      key: state.filters.key,
      filters: state.filters.values,
    });
    state.filters.clearSelection = removedFilters;
  };

  const getEmployeeCardProps = (data) => {
    return {
      firstName: data?.first_name,
      lastName: data?.last_name,
      position: data?.position,
      photoUrl: data?.avatar,
      availability: data?.availability,
      showAvailability: true,
      showLinkUnderline: false,
      hideAvailabilitySelector: true,
      isHoverEnabled: false,
    };
  };
  const getEmployeeReadinessBarProps = (obj) => {
    return {
      recalc: false,
      readiness: obj.current_readiness,
      status: getEmployeeReadinessStatus(obj),
    };
  };
  const getEmployeeReadinessStatus = (employee) => {
    if (employee.current_readiness) {
      return "Only Readiness";
    } else {
      return "No Assignments";
    }
  };
  const getBadgesCounterLevelProps = (obj) => {
    return {
      apprenticeCountBadges: obj.checkpoint.apprentice,
      professionalCountBadges: obj.checkpoint.professional,
      coachCountBadges: obj.checkpoint.coach,
      masterCountBadges: obj.checkpoint.master,
      id: obj.id,
    };
  };

  // Métodos para filtros
  const updateFilter = (filterName, value) => {
    if (filterName in state.filters) {
      state.filters[filterName] = value;
    }
  };

  const clearFilters = () => {
    state.filters = {
      status: "all",
      department: null,
      position: null,
    };
  };

  // Métodos para loading
  const setLoading = (key, value) => {
    if (key in state.loading) {
      state.loading[key] = value;
    }
  };
  const onClickBadgesCounterLevel = (item) => {
    state.showEmployeeBadgesList = true;
    state.selectedEmployee = item;
  };

  instance = {
    state,
    updateFilter,
    clearFilters,
    setLoading,
    getEmployeeCardProps,
    getBadgesCounterLevelProps,
    applyFilters,
    removeFilters,
    getEmployeeReadinessBarProps,
    getEmployeeReadinessStatus,
    onClickBadgesCounterLevel,
  };
  return instance;
}
